import { Form, Formik } from 'formik'
import Calendar from '../calendar/Calendar'
import { convertDateFormat, convertDateFormatCalendar } from '../../utility/genricFunction'
import './tableDateInput.scss'
import { useLocation } from 'react-router-dom';

function TableDateInput(options) {
  const location = useLocation();
  const path = '/inquiry'
  const parseQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const query = {};
    for (const [key, value] of params.entries()) {
      query[key] = value;
    }
    return query;
  };
  
  const queryParams = parseQueryParams(location.search);
  
  const initialValues = {
    dateForFilter: location.pathname === path ? location.search ? queryParams.next_followup_date_to : '': ''
  }

  return (
    <Formik
      initialValues={initialValues}
      validate={(value) => {
        const {dateForFilter} = value
        const filteredDate = dateForFilter && convertDateFormat(dateForFilter)
        options.filterApplyCallback(filteredDate)
      }}
    >{({ values, setFieldValue }) => (
      <Form>
        <Calendar
          name='birthDate'
          type={'date'}
          value={values.dateForFilter ? values.dateForFilter : ""}
          onChange={(values) => setFieldValue('dateForFilter', convertDateFormatCalendar(values))}
          clearable={true}
          placeholder={'Search'}
        />
      </Form>
    )}
    </Formik>
  )
}

export default TableDateInput


